// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c2b05ea7","455":"d245dc94","977":"68c4e9c8"}[chunkId] + ".chunk.js";
};